// extracted by mini-css-extract-plugin
export default {"imageWrap":"file-view_imageWrap__EpSOY","name":"file-view_name__T7mUA"};